export interface IRegionModel extends Components.Schemas.RegionDto {}

export interface IGroupModel extends Components.Schemas.GroupDto {}

export interface IRegionCollection extends Components.Schemas.RegionCollectionDto {}

export interface IGroupCollection extends Components.Schemas.GroupCollectionDto {}

export interface IRegionCollectionFilter extends Paths.RegionControllerListRegions.QueryParameters {}

export interface IGroupCollectionFilter extends Paths.RegionControllerListGroups.QueryParameters {}

export interface IRegionCreateData extends Components.Schemas.CreateRegionDto {}
export interface IRegionUpdateData extends Components.Schemas.UpdateRegionDto {
  id: string;
}

export interface IGroupCreateData extends Components.Schemas.CreateGroupDto {}
export interface IGroupUpdateData extends Components.Schemas.UpdateGroupDto {
  id: string;
}

export enum ERegionSuccessMessage {
  RegionCreate = 'Region has been successfully created',
  RegionEdit = 'Region has been successfully edited',
  RegionDelete = 'Region has been successfully deleted',
  GroupCreate = 'Group has been successfully created',
  GroupEdit = 'Group has been successfully edited',
  GroupDelete = 'Group has been successfully deleted',
}
